import styled from "styled-components";

const Container = styled.div`
  height: 320px;
  border-radius: 0px 24px;
  overflow: hidden;
  @media screen and (min-width: 767px) and (max-width: 991px){
    height: 190px;
  }
  @media screen and (max-width: 767px){
    height: 190px;
  }
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ThumbnailDiamond = (props) => {
  return (
    <Container>
      <Image src={props.image} />
    </Container>
  );
};

export default ThumbnailDiamond;
